export const COLORS = {
  primary: {
    light: '#64B5F6',
    main: '#2196F3',
    dark: '#1976D2',
  },
  secondary: {
    light: '#81C784',
    main: '#4CAF50',
    dark: '#388E3C',
  },
  neutral: {
    lightest: '#FFFFFF',
    light: '#F5F5F5',
    medium: '#E0E0E0',
    dark: '#9E9E9E',
    darkest: '#424242',
  },
  feedback: {
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#F44336',
    info: '#2196F3',
  },
  signal: {
    active: '#2196F3',
    inactive: '#9E9E9E',
  }
};

export const SHADOWS = {
  small: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
  medium: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
  large: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
};

export const TRANSITIONS = {
  fast: 'all 0.2s ease',
  medium: 'all 0.3s ease',
  slow: 'all 0.5s ease',
};